import * as _ from 'lodash';
import * as moment from 'moment';

import { CONSTANT_VALUES } from '../constants/constant-values';
import { CONSTANT_MESSAGES } from '../constants/constants-messages';

export class UtilityFunctions {
    constructor() {

    }

    validatenameString(parameter) {
        let regEx = /[`~,.<>;!@#$%^&*?':"/[\]|{}()=_+-]/;
        let flag = regEx.test(parameter);
        return !flag;
    }

    validateFacilityName(parameter) {
        let regEx = /[`~,.<>;!@#$%^&*?':"/[\]|{}()=_+]/;
        let flag = regEx.test(parameter);
        return !flag;
    }

    validateContact(parameter) {
        let regEx = /[`/\sa-zA-Z~,<>;!@#$%^&*?':"/[\]|{}()=_]/;
        let flag = regEx.test(parameter);
        // let regEx = /^\+{0,1}[\d-.\s]{4,16}$/;
        return flag ? true : false;
    }


    /**
    * Validate Email Id
    */

    validateEmail(email) {
        try {
            let re = /^(([^<>()\[\]\\.,;:\s@']+(\.[^<>()\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(email);
        } catch (e) {
            console.log(e);
        }
    }

    /**
 * Redirecting to member page
 */

    homeScreen(that: any) {
        try {
            if (localStorage.getItem('vendor')) {
                that.router.navigate(['/']);
            }
        } catch (err) {
            console.log(err);
        }
    }

    setFilterCriteria(that, para) {
        try {
            that.filterPara = para;
            switch (that.filterPara) {
                case 'Inactive':
                    that.facilityList = this.makeListUnCheck(that.facilityList);
                    that.groupList = this.makeListUnCheck(that.groupList);
                    that.preferenceList = this.makeListUnCheck(that.preferenceList);
                    that.facilityFilter = [];
                    that.groupFilter = [];
                    that.preferenceFilter = [];
                    break;
                case 'DisabledFacility':
                    that.groupList = this.makeListUnCheck(that.groupList);
                    that.preferenceList = this.makeListUnCheck(that.preferenceList);
                    that.groupFilter = [];
                    that.preferenceFilter = [];
                    break;
                case 'Prefernces':
                    that.facilityList = this.makeListUnCheck(that.facilityList);
                    that.groupList = this.makeListUnCheck(that.groupList);
                    that.facilityFilter = [];
                    that.groupFilter = [];
                    break;
                case 'Groups':
                    that.facilityList = this.makeListUnCheck(that.facilityList);
                    that.preferenceList = this.makeListUnCheck(that.preferenceList);
                    that.facilityFilter = [];
                    that.preferenceFilter = [];
                    break;
                default:
                    that.facilityList = this.makeListUnCheck(that.facilityList);
                    that.groupList = this.makeListUnCheck(that.groupList);
                    that.preferenceList = this.makeListUnCheck(that.preferenceList);
                    that.facilityFilter = [];
                    that.groupFilter = [];
                    that.preferenceFilter = [];
                    break;
            }
        } catch (e) {
            console.log(e);
        }
    }
    maintainFilterState(that) {
        that.openSubMenu1 = false;
        that.openSubMenu2 = false;
        that.openSubMenu3 = false;
        that.selectItem = false;
        that.filterPara = that.filterState;
        that.allFilter = false;
        that.showFilterFacility = false;
        that.showFilterGroup = false;
        that.showFilterPreference = false;
        that.facilityList = this.makeListUnCheck(that.facilityList);
        that.groupList = this.makeListUnCheck(that.groupList);
        that.preferenceList = this.makeListUnCheck(that.preferenceList);
        switch (that.filterState) {
            case 'Inactive':
                that.selectItem = true;
                that.facilityFilter = [];
                that.groupFilter = [];
                that.preferenceFilter = [];
                break;
            case 'DisabledFacility':
                that.facilityFilter = [];
                if (that.filterStateSubMenuList.length > 0) {
                    for (let fac of that.filterStateSubMenuList) {
                        for (let rec of that.facilityList) {
                            if (fac === rec._id) {
                                rec.isChecked = true;
                                that.facilityFilter.push(rec._id);
                                break;
                            }
                        }
                        that.showFilterFacility = true;
                    }
                } else {
                    that.showFilterFacility = false;
                    that.allFilter = true;
                }
                that.groupFilter = [];
                that.preferenceFilter = [];
                break;
            case 'Prefernces':
                that.preferenceFilter = [];
                if (that.filterStateSubMenuList.length > 0) {
                    for (let fac of that.filterStateSubMenuList) {
                        for (let rec of that.preferenceList) {
                            if (fac === rec._id) {
                                rec.isChecked = true;
                                that.preferenceFilter.push(rec._id);
                                break;
                            }
                        }
                        that.showFilterPreference = true;
                    }
                } else {
                    that.showFilterPreference = false;
                    that.allFilter = true;
                }
                that.facilityFilter = [];
                that.groupFilter = [];
                break;
            case 'Groups':
                that.groupFilter = [];
                if (that.filterStateSubMenuList.length > 0) {
                    for (let fac of that.filterStateSubMenuList) {
                        for (let rec of that.groupList) {
                            if (fac === rec._id) {
                                rec.isChecked = true;
                                that.groupFilter.push(rec._id);
                                break;
                            }
                        }
                        that.showFilterGroup = true;
                    }
                } else {
                    that.showFilterGroup = false;
                    that.allFilter = true;
                }
                that.facilityFilter = [];
                that.preferenceFilter = [];
                break;
            default:
                that.allFilter = true;
                that.facilityFilter = [];
                that.groupFilter = [];
                that.preferenceFilter = [];
                that.filterStateSubMenuList = [];
                break;
        }
    }

    addFacilityForFilter(that, e, facilityId) {
        try {
            if (e.target.checked) {
                that.facilityFilter.push(facilityId);
            } else {
                that.facilityFilter.splice(that.facilityFilter.indexOf(facilityId), 1);
            }
        } catch (e) {
            console.log(e);
        }
    }

    addGroupForFilter(that, e, groupId) {
        try {
            if (e.target.checked) {
                that.groupFilter.push(groupId);
            } else {
                that.groupFilter.splice(that.groupFilter.indexOf(groupId), 1);
            }
        } catch (e) {
            console.log(e);
        }
    }
    addPreferencesForFilter(that, e, facilityId) {
        try {
            if (e.target.checked) {
                that.preferenceFilter.push(facilityId);
            } else {
                that.preferenceFilter.splice(that.preferenceFilter.indexOf(facilityId), 1);
            }
        } catch (e) {
            console.log(e);
        }
    }
    makeListUnCheck(list) {
        list.map(function (rec: any) {
            rec.isChecked = false;
            return rec;
        });
        return list
    }

    removeSpace(that, obj, key) {
        try {
            let regexp = /.*[^ ].*/;
            if (!obj) {
                if (that[key]) {
                    if (!regexp.test(that[key])) {
                        that[key] = '';
                    }
                }
            } else {
                if (that[obj][key]) {
                    if (!regexp.test(that[obj][key])) {
                        that[obj][key] = '';
                    }
                }
            }
        } catch (err) {
            console.log(err);
        }
    }

    removeNumaricValue(that: any, key) {
        try {
            if (that[key]) {
                that[key] = that[key].replace(/[0-9]/g, '');
            }
        } catch (err) {
            console.log(err);
        }
    }

    /**
     * Add multiple member from file
     *
     * @param {any} input
     * @returns
     *
     * @memberOf UtilityFunctions
     */
    getMembersFromFile(input) {
        try {
            let that = this;
            let file = input.files[0];
            let lines: any;
            let members = [];
            let validateUploadMemberLog = [];
            let logList = [];
            let logObj;
            return new Promise((resolve, reject) => {
                if (file && file.name.indexOf('csv') !== -1) {
                    let reader = new FileReader();
                    reader.onload = function () {
                        let text = reader.result;
                        lines = text.split(/\r?\n/);
                        let array = lines[0].split(',');
                        if (that.validateFileKeyColumns(array, 'addMember')) {
                            lines.forEach(function (line, i) {
                                validateUploadMemberLog = [];
                                if (line !== '' && line !== ',,,,,') {
                                    if (i !== 0) {
                                        let lineObj = line.split(',');
                                        let obj = {
                                            emailId: lineObj[0] ? lineObj[0].trim() : '',
                                            contactNumber: lineObj[1] ? lineObj[1].trim() : '',
                                            membershipId: lineObj[2] ? lineObj[2].trim() : '',
                                            firstName: lineObj[3] ? lineObj[3].trim() : '',
                                            lastName: lineObj[4] ? lineObj[4].trim() : '',
                                            type: lineObj[5] ? lineObj[5].trim() : ''
                                        };
                                        validateUploadMemberLog = that.validateMandatoryFields(obj, members, validateUploadMemberLog);
                                        if (validateUploadMemberLog.length <= 0) {
                                            members.push(obj);
                                        } else {
                                            logObj = {
                                                'obj': obj,
                                                'logList': validateUploadMemberLog
                                            }
                                            logList.push(logObj);
                                        }
                                        if (i <= (lines.length - 1)) {
                                            let result =
                                                {
                                                    'members': members,
                                                    'logList': logList,
                                                    'message': ''
                                                };
                                            resolve(result);
                                        }
                                    }
                                } else {
                                    resolve([]);
                                }
                            });
                        } else {
                            resolve({ members: [], message: CONSTANT_MESSAGES.INVALID_FILE_COLUMNS });
                        }

                    };
                    reader.readAsText(file);
                } else {
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    hasMemberWithDuplicateContactNumber(contactNumber, members) {
        return _.find(members, { contactNumber: contactNumber });
    }
    /**
     * Validate member object fields
     *
     * @param {any} rec
     * @param {any} members
     * @returns
     *
     * @memberOf UtilityFunctions
     */
    validateMandatoryFields(rec, members, validateUploadMemberLog) {

        try {
            if (!(rec.membershipId + '').trim()) {
                validateUploadMemberLog.push(CONSTANT_VALUES.LOG.membershipId);
            } else if (!(this.validateEmail(rec.emailId))) {
                validateUploadMemberLog.push(CONSTANT_VALUES.LOG.invalidEmailId);
            } else if (this.validateContact(rec.contactNumber) || !(rec.contactNumber + '').trim()) {
                validateUploadMemberLog.push(CONSTANT_VALUES.LOG.contactNumber);
            }
            else if (rec.contactNumber.length < 4 || rec.contactNumber.length > 16) {
                validateUploadMemberLog.push(CONSTANT_VALUES.LOG.contactNumberLength);
            } else if (members.length && this.hasMemberWithDuplicateContactNumber(rec.contactNumber, members)) {
                validateUploadMemberLog.push(CONSTANT_VALUES.LOG.contactNumberDuplicate);
            } else if (!rec.firstName || !(rec.firstName + '').trim()) {
                validateUploadMemberLog.push(CONSTANT_VALUES.LOG.firstName);
            } else if (!rec.lastName || !(rec.lastName + '').trim()) {
                validateUploadMemberLog.push(CONSTANT_VALUES.LOG.lastName);
            } else {
                if ((rec.type + '').trim().toLowerCase() === 'tenant') {
                    rec.type = 'Tenant';
                } else if ((rec.type + '').trim().toLowerCase() === 'owner') {
                    rec.type = 'Owner';
                } else {
                    validateUploadMemberLog.push(CONSTANT_VALUES.LOG.type);
                }
            }
            return validateUploadMemberLog;
        } catch (e) {
            console.log(e);
        }
    }
    /**
     * Validate the key of colomans
     *
     * @param {any} columns
     * @param {any} fileType
     * @returns
     *
     * @memberof UtilityFunctions
     */
    validateFileKeyColumns(columns, fileType) {
        let uploadFileKeyColumns = columns;
        let flag = true;
        let templateFileKeyColumns;
        if ('addMember' == fileType) {
            templateFileKeyColumns = CONSTANT_VALUES.CSV_STRUCTURE_MEMBER
        } else if (fileType == 'addBooking') {
            templateFileKeyColumns = CONSTANT_VALUES.CSV_STRUCTURE_BOOKING;
        }
        let len = Math.max(templateFileKeyColumns.length, uploadFileKeyColumns.length);
        for (var i = 0; i < len; i++) {
            if (templateFileKeyColumns[i] === uploadFileKeyColumns[i]) {
            } else {
                flag = false;
                break;
            }
        }
        return flag;
    }

    getBookingsFromFile(input) {
        try {
            let that = this;
            let logList = [];
            let file = input.files[0];
            let lines: any;
            let booking = [];
            let validateLog = [];
            let logObj;
            return new Promise((resolve, reject) => {
                if (file && file.name.indexOf('csv') !== -1) {
                    let reader = new FileReader();
                    reader.onload = function () {
                        let text = reader.result;
                        lines = text.split(/\r?\n/);
                        let array = lines[0].split(',');
                        if (that.validateFileKeyColumns(array, 'addBooking')) {
                            lines.forEach(function (line, i) {
                                if (line !== '' && line !== ',,,,,,,,') {
                                    if (i !== 0) {
                                        validateLog = [];
                                        let lineObj = line.split(',');
                                        let obj = {
                                            membershipId: lineObj[0] ? lineObj[0].trim() : '',
                                            contactNumber: lineObj[1] ? lineObj[1].trim() : '',
                                            facilityName: lineObj[2] ? lineObj[2].trim() : '',
                                            category: lineObj[3] ? lineObj[3].trim() : '',
                                            bookingDate: lineObj[4] ? lineObj[4].trim() : '',
                                            startTime: lineObj[5] ? lineObj[5].trim() : '',
                                            endTime: lineObj[6] ? lineObj[6].trim() : '',
                                            unitName: lineObj[7] ? lineObj[7].trim() : '',
                                            title: lineObj[2] ? lineObj[2].trim() : '',
                                            attendees: lineObj[8] ? lineObj[8].trim() : '',
                                        };
                                        let bookingObj = that.validateMandatoryFieldsForBookings(obj, validateLog);
                                        if (bookingObj.validateLog.length <= 0) {
                                            booking.push(bookingObj.obj);
                                        } else {
                                            logObj = {
                                                'obj': bookingObj.obj,
                                                'logList': bookingObj.validateLog
                                            }
                                            logList.push(logObj);
                                        }
                                        if (i <= (lines.length - 1)) {
                                            resolve({ booking: booking, loglList: logList, message: '' });
                                        }
                                    }
                                } else {
                                    resolve({});
                                }
                            });
                        } else {
                            resolve({ bookings: [], message: CONSTANT_MESSAGES.INVALID_FILE_COLUMNS });
                        }
                    };
                    reader.readAsText(file);
                } else {
                }
            });
        } catch (e) {
            console.log(e);
        }
    }

    validateMandatoryFieldsForBookings(obj, validateLog) {
        let regex = /^[0-9]*$/;
        let dateFormat = /^\d{1,2}\/\d{1,2}\/\d{2,4}$/;
        for (var prop in obj) {
            if (!obj[prop]) {
                validateLog.push(CONSTANT_VALUES.LOG[prop]);
            }
        }
        if (obj.contactNumber && this.validateContact(obj.contactNumber)) {
            validateLog.push(CONSTANT_VALUES.LOG.inValidContactNumber);
        }
        if (obj.contactNumber && obj.contactNumber.length < 4 || obj.contactNumber.length > 16) {
            validateLog.push(CONSTANT_VALUES.LOG.contactNumberLength);
        }
        if (obj.facilityName && !this.validateFacilityName(obj.facilityName)) {
            validateLog.push(CONSTANT_VALUES.LOG.InValidFacilityName);
        }
        if (obj.attendees && !regex.test(obj.attendees)) {
            validateLog.push(CONSTANT_VALUES.LOG.attendeesCount);
        }
        if (obj.bookingDate && !dateFormat.test(obj.bookingDate)) {
            validateLog.push(CONSTANT_VALUES.LOG.InvalidBookingDateFormat);
        } else if (obj.bookingDate && obj.startTime && obj.endTime) {
            let bookingStartDate = (obj.bookingDate + ' ' + obj.startTime).toString();
            let bookingEndDate = (obj.bookingDate + ' ' + obj.endTime).toString();

            let validFlagForBookingStartDate = new Date(bookingStartDate);
            let validFlagForBookingEndDate = new Date(bookingEndDate);
            if (!validFlagForBookingStartDate || validFlagForBookingStartDate.toString() == 'Invalid Date') {
                validateLog.push(CONSTANT_VALUES.LOG.InvalidBookingDate);
            } else if (!validFlagForBookingEndDate || validFlagForBookingEndDate.toString() == 'Invalid Date') {
                validateLog.push(CONSTANT_VALUES.LOG.InvalidBookingDate);
            } else {
                obj.endTime =  this.maketimeZoneOfsetDate(validFlagForBookingEndDate, true);
                obj.startTime = this.maketimeZoneOfsetDate(validFlagForBookingStartDate, true);
            }
        }
        let bookingObj = {
            validateLog: validateLog,
            obj: obj
        }
        return bookingObj;
    }

    maketimeZoneOfsetDate(date, flag?) {
        let vendor;
        let timeZoneDate;
        if (localStorage.getItem('vendor')) {
            vendor = JSON.parse(atob(localStorage.getItem('vendor')));
            timeZoneDate = moment(date).utcOffset(vendor.timezoneOffset * -1, flag);
        }
        return timeZoneDate;
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utility-functions.ts